import { render, staticRenderFns } from "./Assignment.vue?vue&type=template&id=6fa71748&scoped=true"
import script from "./Assignment.vue?vue&type=script&lang=js"
export * from "./Assignment.vue?vue&type=script&lang=js"
import style0 from "./Assignment.vue?vue&type=style&index=0&id=6fa71748&prod&scoped=true&lang=css"
import style1 from "./Assignment.vue?vue&type=style&index=1&id=6fa71748&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa71748",
  null
  
)

export default component.exports